import React, {PureComponent} from "react";
import cn from 'classnames';
import { ToastContainer } from 'react-toastify';
import LoaderBlock from "../../Molecules/LoaderBlock";

import classes from "./styles.module.scss";
import sharedStyles from "../../../styles/scss/shared.module.scss";
import BreadCrumbs from "../../../components/Atoms/BreadCrumbs";

class Base extends PureComponent {
    render() {
        const {
            global: {collapseContent, loading, isDataFetching},
            breadCrumbs: {list},
            bottomElement
        } = this.props;

        const wrapClasses = cn({
            [classes.contentContainer]: loading || isDataFetching,
            [sharedStyles.collapseContent]: collapseContent
        })
        const breadCrumbsExist = !!list[0];
        return (
            <>
                {(loading || isDataFetching) && <LoaderBlock/>}
                <section className={wrapClasses}>
                    <section
                        className={cn(
                            classes.contentWrap,
                            sharedStyles.mainCentering,
                        )}
                    >
                        {breadCrumbsExist && <BreadCrumbs list={list}/>}
                        {this.props.children}
                    </section>
                    {bottomElement && (
                        <div
                            className={classes.bottomContent}
                        >
                            <div className={classes.bottomWrap}>{bottomElement}</div>
                        </div>
                    )}
                </section>
                <ToastContainer hideProgressBar  />
            </>
        );
    }
}

export default Base;
